import type { BaseKeyFunction } from "../../../../lib/types/baseKeyFunction";

export const keyQueueSkips: BaseKeyFunction = () => ["queue-skips"];
